module.exports = "/images/up.png?1515da08683ea8ecb3ac001e28528066";